/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @flow
 */

import * as React from 'react';

export default function SuspenseTreeList(_: {}): React$Node {
  return <div>Activity slices not implemented yet</div>;
}
